<style>
.left-popup-setting .v-image__image--cover {
  filter: brightness(0.2) !important;
}
.left-popup-setting .app-medium-font.white--text {
  color: #000 !important;
  caret-color: #000 !important;
}
.left-popup-setting selected .list-item .v-image__image--cover {
  filter: brightness(0.2) !important;
}
.left-popup-setting .list-item:hover {
  background: #55eef3f8;
}
</style>

<template>
  <div class="feed-body">
    <div class="feed-contents">
      <div class="hidden-md-and-up w-100 px-3">
        <v-menu offset-y rounded="lg" left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" class="mb-2">
              <v-icon>mdi-menu</v-icon>
            </v-btn>
          </template>
          <v-list class="pa-0 left-popup-setting" style="width: 260px;">
            <search-list-card
              :title="category.title"
              :image="category.image"
              :image_selected="category.image_selected"
              v-for="category in categories"
              :key="category.title"
            />
          </v-list>
        </v-menu>
      </div>
<div 
  v-if="contents.length === 0 && !loading"
  class="no-results-card mt-5"
  :class="{ 'dark-mode': $vuetify.theme.dark }"
>
  <div class="background-pattern"></div>
  <div class="floating-particles">
    <div class="particle" v-for="i in 6" :key="i"></div>
  </div>
  
  <div class="illustration-container">
    <div class="illustration-wrapper">
      <svg width="160" height="160" viewBox="0 0 200 200" fill="none" class="main-illustration">
        <defs>
          <linearGradient id="circleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" :stop-color="$vuetify.theme.dark ? '#0ea5e9' : '#3b82f6'" />
            <stop offset="100%" :stop-color="$vuetify.theme.dark ? '#06b6d4' : '#1d4ed8'" />
          </linearGradient>
          <linearGradient id="xGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" :stop-color="$vuetify.theme.dark ? '#f43f5e' : '#ec4899'" />
            <stop offset="100%" :stop-color="$vuetify.theme.dark ? '#e11d48' : '#be185d'" />
          </linearGradient>
        </defs>
        
        <!-- Animated background circle -->
        <circle cx="100" cy="100" r="82.5" stroke="url(#circleGradient)" stroke-width="8" 
                fill="none" class="circle-bg" stroke-dasharray="518" stroke-dashoffset="518">
          <animate attributeName="stroke-dashoffset" values="518;0" dur="2s" begin="0.5s" fill="freeze"/>
        </circle>
        
        <!-- Animated X mark -->
        <g class="x-mark">
          <path d="M70 70L130 130" stroke="url(#xGradient)" stroke-width="8" 
                stroke-linecap="round" stroke-dasharray="85" stroke-dashoffset="85">
            <animate attributeName="stroke-dashoffset" values="85;0" dur="0.8s" begin="1.5s" fill="freeze"/>
          </path>
          <path d="M130 70L70 130" stroke="url(#xGradient)" stroke-width="8" 
                stroke-linecap="round" stroke-dasharray="85" stroke-dashoffset="85">
            <animate attributeName="stroke-dashoffset" values="85;0" dur="0.8s" begin="1.8s" fill="freeze"/>
          </path>
        </g>
      </svg>
      
      <!-- Pulsing rings -->
      <div class="pulse-ring ring-1"></div>
      <div class="pulse-ring ring-2"></div>
      <div class="pulse-ring ring-3"></div>
    </div>
  </div>

  <div class="content">
    <h3 class="title">{{ $t("no_search_result") }}</h3>
   
  </div>
</div>
      <v-list
        class="pt-3 w-100"
        v-else-if="!loading"
        style="background-color: #0000;"
      >
        <v-list-item v-for="(item, index) in contents" :key="index">
          <v-list-item-title
            v-if="item.header"
            class="app-bold-font font-20 white--text"
            :class="{ 'mt-5': index != 0, 'mb-3': true }"
          >
            {{
              item.header == "Agency"
                ? $t("agency")
                : item.header == "Needs"
                ? $t("needs")
                : item.header == "Events"
                ? $t("events")
                : item.header == "Blogs"
                ? $t("blogs")
                : item.header
            }}
          </v-list-item-title>
          <v-list-item-title
            v-else-if="item.type == 'Agency' || item.type == 'Volunteer'"
            @click="selectUser(item)"
            class="list-user-item url-button bg-white pt-3 rounded-lg font-bold font-16 dark-gray-color mt-3"
          >
            <div>
              <editable-avatar
                :editable="false"
                :image="item.thumbnail ? item.thumbnail : item.image"
                :size="40"
                class="mr-2 ml-3"
              />
              {{ item.name }}
            </div>
            <v-divider class="mt-3" />
          </v-list-item-title>
          <v-list-item-title v-else-if="item.type == 'Need'">
            <agency-need-card :need="item" class="mb-3" />
          </v-list-item-title>
          <v-list-item-title v-else-if="item.type == 'Event'">
            <feed-event-card :_id="item._id" />
          </v-list-item-title>
          <v-list-item-title v-else-if="item.type == 'Blog'">
            <blog-card :blog="item" class="mb-3" />
          </v-list-item-title>
          <v-list-item-title v-else>
            {{ item }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
      <v-progress-circular indeterminate color="amber" v-else class="mt-15" />
    </div>
    <v-snackbar v-model="snackbar">
      {{ errorMessage }}
    </v-snackbar>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import EditableAvatar from "@/components/EditableAvatar.vue";
import FeedEventCard from "../event_feeds/FeedEventCard.vue";
import AgencyNeedCard from "../agency/needs/AgencyNeedCard.vue";
import BlogCard from "../blogs/BlogCard.vue";
import SearchListCard from "./SearchListCard.vue";

export default {
  components: {
    EditableAvatar,
    FeedEventCard,
    AgencyNeedCard,
    BlogCard,
    SearchListCard
  },
  data() {
    return {
      loading: false,
      errorMessage: null,
      snackbar: false,
      loadCompleted: -1,
      loadingMore: false,
      contents: [],
      categories: [
        {
          title: "All",
          image: require("@/assets/svg/search/icon_all.svg"),
          image_selected: require("@/assets/svg/search/icon_all_selected.svg")
        },
        {
          title: "Volunteer",
          image: require("@/assets/svg/search/icon_volunteer.svg"),
          image_selected: require("@/assets/svg/search/icon_volunteer_selected.svg")
        },
        {
          title: "Agency",
          image: require("@/assets/svg/search/icon_agency.svg"),
          image_selected: require("@/assets/svg/search/icon_agency_selected.svg")
        },
        {
          title: "Needs",
          image: require("@/assets/svg/search/icon_needs.svg"),
          image_selected: require("@/assets/svg/search/icon_needs_selected.svg")
        },
        {
          title: "Events",
          image: require("@/assets/svg/search/icon_events.svg"),
          image_selected: require("@/assets/svg/search/icon_events_selected.svg")
        },
        {
          title: "Blogs",
          image: require("@/assets/svg/search/icon_blogs.svg"),
          image_selected: require("@/assets/svg/search/icon_blogs_selected.svg")
        }
      ]
    };
  },
  methods: {
    ...mapActions("search", {
      getSearchContents: "getSearchContents",
      loadMore: "loadMoreNotifications"
    }),
    showErrorMessage(message) {
      this.errorMessage = message;
      this.snackbar = true;
    },
    onSearchContents() {
      this.loading = true;
      this.getSearchContents({
        key: this.$route.query.q,
        category: this.$route.query.category
      })
        .then(res => {
          this.loading = false;
          this.contents = res;
        })
        .catch(res => {
          this.loading = false;
          console.log(res.response.data.message);
        });
    },
    selectUser(item) {
      if (item.type == "Agency") {
        this.$router.push({
          name: "agency-profile-details",
          params: { id: item._id }
        });
      } else if (item.type == "Volunteer") {
        this.$router.push({
          name: "volunteer-profile-details",
          params: { id: item._id }
        });
      }
    }
  },
  computed: {
    ...mapGetters("notification", {
      notifications: "getAllNotifications"
    })
  },
  watch: {
    "$route.query": function() {
      this.onSearchContents();
    }
  },
  mounted() {
    this.onSearchContents();
  }
};
</script>
<style scoped>
.feed-body {
  width: 100%;
  min-width: 200px;
  margin-left: 0px;
  margin-right: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.feed-contents {
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
}
@media (max-width: 959px) {
  .feed-contents {
    padding-top: 4px;
  }
}




.no-results-card {
  position: relative;
  background: linear-gradient(145deg, 
    rgba(255, 255, 255, 0.1) 0%, 
    rgba(255, 255, 255, 0.05) 100%);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 60px 40px;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  transition: all 0.4s cubic-bezier(0.23, 1, 0.320, 1);
  overflow: hidden;
  animation: fadeInUp 0.8s ease-out;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.no-results-card:hover {
  transform: translateY(-8px);
  box-shadow: 
    0 32px 64px rgba(0, 0, 0, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.no-results-card.dark-mode {
  background: linear-gradient(145deg, 
    rgba(15, 23, 42, 0.8) 0%, 
    rgba(30, 41, 59, 0.9) 100%);
  border-color: rgba(148, 163, 184, 0.2);
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(148, 163, 184, 0.1);
}

.background-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    radial-gradient(circle at 20% 20%, rgba(59, 130, 246, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 80%, rgba(236, 72, 153, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 40% 60%, rgba(34, 197, 94, 0.1) 0%, transparent 50%);
  animation: patternShift 20s ease-in-out infinite;
}

.floating-particles {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.particle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
}

.particle:nth-child(1) { top: 20%; left: 10%; animation-delay: 0s; }
.particle:nth-child(2) { top: 60%; left: 20%; animation-delay: 1s; }
.particle:nth-child(3) { top: 40%; left: 80%; animation-delay: 2s; }
.particle:nth-child(4) { top: 80%; left: 70%; animation-delay: 3s; }
.particle:nth-child(5) { top: 30%; left: 60%; animation-delay: 4s; }
.particle:nth-child(6) { top: 70%; left: 40%; animation-delay: 5s; }

.illustration-container {
  position: relative;
  margin-bottom: 40px;
  z-index: 2;
}

.illustration-wrapper {
  position: relative;
  display: inline-block;
  animation: bounce 2s ease-in-out infinite;
}

.main-illustration {
  filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.1));
  transition: transform 0.3s ease;
}

.no-results-card:hover .main-illustration {
  transform: scale(1.05) rotate(2deg);
}

.pulse-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 2px solid rgba(59, 130, 246, 0.2);
  border-radius: 50%;
  animation: pulse 2s ease-in-out infinite;
}

.ring-1 { width: 180px; height: 180px; animation-delay: 0s; }
.ring-2 { width: 200px; height: 200px; animation-delay: 0.7s; }
.ring-3 { width: 220px; height: 220px; animation-delay: 1.4s; }

.content {
  position: relative;
  z-index: 2;
}

.title {
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(135deg,  #ffffff 0%, #b1d8ee 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 16px;
  animation: titleGlow 3s ease-in-out infinite alternate;
}

.dark-mode .title {
  background: linear-gradient(135deg,  #79bde7 0%, #b1d8ee 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.subtitle {
  font-size: 1.1rem;
  color: rgba(100, 116, 139, 0.8);
  margin-bottom: 32px;
  line-height: 1.6;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.dark-mode .subtitle {
  color: rgba(203, 213, 225, 0.8);
}

.action-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-primary, .btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 24px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  cursor: pointer;
  border: none;
  text-decoration: none;
  position: relative;
  overflow: hidden;
}

.btn-primary {
  background: linear-gradient(135deg, #33383a 0%, #3b7ca1 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(59, 130, 246, 0.4);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.1);
  color: #374151;
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.dark-mode .btn-secondary {
  color: #e5e7eb;
  border-color: rgba(148, 163, 184, 0.2);
}

.btn-secondary:hover {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

/* Responsive Design */
@media (max-width: 768px) {
  .no-results-card {
    padding: 40px 24px;
    margin: 16px;
    min-height: 350px;
  }
  
  .title {
    font-size: 1.75rem;
  }
  
  .subtitle {
    font-size: 1rem;
  }
  
  .action-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .btn-primary, .btn-secondary {
    width: 100%;
    max-width: 200px;
  }
}

@media (max-width: 480px) {
  .no-results-card {
    padding: 32px 20px;
  }
  
  .main-illustration {
    width: 120px;
    height: 120px;
  }
  
  .title {
    font-size: 1.5rem;
  }
  
  .subtitle {
    font-size: 0.9rem;
  }
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

@keyframes pulse {
  0% {
    transform: translate(-50%, -50%) scale(0.8);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0;
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
}

@keyframes patternShift {
  0%, 100% {
    transform: translateX(0) translateY(0);
  }
  25% {
    transform: translateX(5px) translateY(-5px);
  }
  50% {
    transform: translateX(-5px) translateY(5px);
  }
  75% {
    transform: translateX(5px) translateY(5px);
  }
}

@keyframes titleGlow {
  0% {
    text-shadow: 0 0 20px rgba(102, 126, 234, 0.5);
  }
  100% {
    text-shadow: 0 0 30px rgba(118, 75, 162, 0.8);
  }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .no-results-card {
    border: 2px solid;
    background: solid;
  }
  
  .title {
    -webkit-text-fill-color: initial;
    color: inherit;
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .no-results-card,
  .illustration-wrapper,
  .pulse-ring,
  .particle,
  .main-illustration {
    animation: none;
  }
  
  .no-results-card:hover {
    transform: none;
  }
}
</style>
